import * as store from '@/store';
import {EDITOR_MODE} from '@/Constant';
import {useEffect, useState, useRef} from 'react';
import {showTemplateRecommendBuried} from '@/buried/common';

export const useShowTemplate = ({
    haveTemplate,
    isDocEmptyWithSpace,
    docGuid,
    mode,
}: {
    haveTemplate: boolean;
    isDocEmptyWithSpace: boolean;
    docGuid: string;
    mode: string;
}) => {
    // const aiTemplateActive = store.getIsAiTemplateActive();

    // 模板展示条件
    // 内容状态
    // const isEmptyDoc = isNew || isEmpty; ————isNew的判断属于历史老债务，这个逻辑很坑，而且不好控制更新，先去掉。目前isEmpty可以完全满足需求
    const [showDefaultTemplate, setShowDefaultTemplate] = useState(false);
    const [showTemplate, setShowTemplate] = useState(false); // 控制动画是否执行完成后真正消失
    const [isAllowShowTemplate, setIsAllowShowTemplate] = useState(true);

    const timer: any = useRef(null);

    useEffect(() => {
        setIsAllowShowTemplate(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [docGuid]);

    useEffect(() => {
        const curDocument = store.getCurDocument();
        // 文档模式
        const isShowMode = (mode === EDITOR_MODE.edit || mode === EDITOR_MODE.meeting || mode === EDITOR_MODE.normal);
        // 文档类型
        const isShowType = curDocument?.type !== 2;
        setShowDefaultTemplate(isDocEmptyWithSpace && isShowMode && isShowType && haveTemplate);

    }, [isDocEmptyWithSpace, haveTemplate, docGuid, mode]);

    useEffect(() => {
        if (!isAllowShowTemplate) {
            return;
        }

        if (showDefaultTemplate) {
            setShowTemplate(true);
            showTemplateRecommendBuried();
        } else {
            timer.current = setTimeout(() => {

                setShowTemplate(false);
            }, 166); // 等待消失动画执行完成之后再关闭
        }
        return () => {
            timer.current && clearTimeout(timer.current);
        };
    }, [isAllowShowTemplate, showDefaultTemplate]);

    return {
        showDefaultTemplate,
        showTemplate,
        isAllowShowTemplate,
        setIsAllowShowTemplate,
        setShowTemplate,
    };
};
